import React from 'react';
import PropTypes from 'prop-types';
import './logo.css';
import * as routes from '../../../../constants/routes';
import { Link } from 'react-router-dom';

const Logo = (props) => {
  let contents = (
    <React.Fragment>
      <img src={props.image} alt={props.alt} />
      {
        (props.appTitle)
          ? <span className="divider">
            <span className="app-title">
              {props.appTitle}
            </span>
          </span>
          : null
      }
    </React.Fragment>
  );

  let linkedContents = (props.link) ?
    <a className={props.className} href={props.link}>
      {contents}
    </a> :
    <Link className={props.className} to={{ pathname: routes.ROOT_ROUTE }}>
      {contents}
    </Link>;
  
  return (
    <div className="logo">
      {linkedContents}
    </div>
  );
}

Logo.propTypes = {
  alt: PropTypes.string.isRequired,
  appTitle: PropTypes.string,
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
  link: PropTypes.string
}

export default Logo;


// WEBPACK FOOTER //
// ./src/shared/components/presentation/logo/Logo.js